import CryptoJS from "crypto-js";

const API_KEY = process.env.APP_KEY;
const API_PATH = process.env.MIX_API_PATH;

// pacemis server
/*---------------------------------------------------------*/
// const API_Link = "http://misr.pacemis.com:83/api/";
// const API_SRC = "http://misr.pacemis.com:83/";
/*---------------------------------------------------------*/

// local
//  const API_Link = "http://localhost/mirs/backend/public/api/";
//  const API_SRC = "http://localhost/mirs/backend/public";

// latest path
const API_Link = "http://misr.pacemis.com:76/api/";
const API_SRC = "http://misr.pacemis.com:76/";

var moment = require("moment");

const validateHeader = () => {
    return CryptoJS.MD5("P@ce-" + moment().format("YYYY-MM-DD") + "-T3c4").toString();
}


export { API_KEY, API_PATH, API_Link, API_SRC , validateHeader};